import PropTypes from "prop-types";

// Material UI Components
import { makeStyles } from "@mui/styles";

import { useSelector } from "react-redux";

// Core Components
import MDCButton from "../../core/MDCButton";
import MDCLabel from "../../core/MDCLabel";

// Theme
import theme from "../../../themes/mdc-theme";

// Constants
import { QES_VENDOR_SELECTION } from "../../../constants/PluginConstants";

const useStyles = makeStyles(() => ({
  providerSection: {
    width: "100%",
  },
  sectionDescription: {
    margin: "0.25rem 0 0",
    color: theme.palette.MDCColors.color18,
    fontSize: "13px",
    fontFamily: theme.palette.typography.fontFamily,
  },
  providerStack: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    marginTop: "0.75rem",
  },
  providerCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "12px 14px",
    width: "100%",
    boxSizing: "border-box",
    background: theme.palette.MDCColors.white,
    border: `1px solid ${theme.palette.MDCColors.color21}`,
    borderRadius: "8px",
    // MDCButton's &.MuiButton-* rules are (0,2,0) — !important is required to
    // slim the button from inside this card; MDCButton itself stays untouched
    "& button": {
      whiteSpace: "nowrap",
      flexShrink: 0,
      margin: 0,
      padding: "4px 14px !important",
      fontSize: "13px !important",
      minWidth: "unset !important",
    },
  },
  providerIdentity: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0,
  },
  providerText: {
    minWidth: 0,
  },
  providerLogo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "72px",
    height: "32px",
    borderRadius: "6px",
    flexShrink: 0,
    color: theme.palette.MDCColors.white,
    fontWeight: 800,
    fontSize: "14px",
    fontFamily: theme.palette.typography.fontFamily,
  },
  providerName: {
    margin: 0,
    color: theme.palette.MDCColors.textColor,
    fontWeight: 700,
    fontSize: "14px",
    fontFamily: theme.palette.typography.fontFamily,
  },
  providerDescription: {
    margin: "2px 0 0",
    color: theme.palette.MDCColors.color18,
    fontSize: "12px",
    fontFamily: theme.palette.typography.fontFamily,
    // Long descriptions clamp instead of inflating the card
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
}));

const QESProviderSelection = ({
  personenform,
  requestId,
  qesValidationResult,
  startSigning,
  onStartSigning,
}) => {
  const classes = useStyles();

  const providers = useSelector((state) => state?.pluginReducer?.qesProviders);

  const handleStart = async (provider) => {
    const response = await startSigning(
      requestId,
      provider.providerId,
      personenform
    );
    onStartSigning?.(provider, personenform, response);
  };

  return (
    <div className={classes.providerSection}>
      <MDCLabel label={QES_VENDOR_SELECTION.SECTION_TITLE} variant="h6" />
      <p className={classes.sectionDescription}>
        {QES_VENDOR_SELECTION.SECTION_DESCRIPTION}
      </p>
      <div className={classes.providerStack}>
        {(providers || []).map((providerDetails) => {
          const brandColor =
            providerDetails?.colorCode || theme.palette.MDCColors.color23;

          return (
            <div
              key={providerDetails?.providerId}
              className={classes.providerCard}
            >
              <div className={classes.providerIdentity}>
                <div
                  className={classes.providerLogo}
                  style={{ background: brandColor }}
                >
                  {providerDetails?.displayName}
                </div>
                <div className={classes.providerText}>
                  {/* <p className={classes.providerName}>
                    {providerDetails?.displayName}
                  </p> */}
                  {providerDetails?.description && (
                    <p className={classes.providerDescription}>
                      {providerDetails?.description}
                    </p>
                  )}
                </div>
              </div>
              <MDCButton
                variant="outlined"
                label={QES_VENDOR_SELECTION.START_SIGNING}
                disabled={qesValidationResult !== true}
                onClick={() => handleStart(providerDetails)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

QESProviderSelection.propTypes = {
  personenform: PropTypes.string,
  requestId: PropTypes.string,
  qesValidationResult: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  startSigning: PropTypes.func,
  onStartSigning: PropTypes.func,
};

export default QESProviderSelection;
